/**
 * Lógica de cálculo de la cotización.
 *
 * Esta función debe ser idéntica en frontend y backend para que el cliente
 * no pueda manipular el total. Cuando Alejandro construya el backend, esta
 * misma función vive del lado servidor y se valida antes de guardar.
 */

const TOPE_DESCUENTO_PCT = 25;

export const calcularCotizacion = (quote) => {
  const subtotalProductos = (quote.productos || []).reduce(
    (s, p) => s + (p.precioFinal || 0),
    0
  );

  const licExtra = quote.pago?.licenciaPrepagada
    ? quote.pago.licenciaPrepagadaPrecio || 0
    : 0;

  const subtotal = subtotalProductos + licExtra;

  let descPct = 0;
  if (quote.descuentos?.bundle) descPct += quote.descuentos.bundlePct || 0;
  if (quote.descuentos?.elementosPrevios) descPct += quote.descuentos.elementosPreviosPct || 0;
  (quote.descuentos?.codigos || []).forEach((c) => {
    descPct += c.descuento || 0;
  });
  descPct = Math.min(descPct, TOPE_DESCUENTO_PCT);

  const descuentoTotal = subtotal * (descPct / 100);
  const ajuste = quote.ajusteManual || 0;
  const total = Math.max(0, subtotal - descuentoTotal + ajuste);

  return {
    subtotal,
    descuentoTotal,
    descuentoPct: descPct,
    total,
  };
};

/**
 * Calcular un proyecto Click & Xperience individual
 */
export const calcularProyectoCX = (proy) => {
  const f1Total = (proy.fase1 || []).reduce((s, i) => s + (i.precio || 0), 0);
  const f2Total = (proy.fase2 || []).reduce((s, i) => s + (i.precio || 0), 0);
  const f3Total = (proy.fase3 || []).reduce((s, i) => s + (i.precio || 0), 0);
  const desc3D = f1Total * ((proy.descuento3D || 0) / 100);
  const descTip = proy.descTipologias ? f2Total * 0.1 : 0;
  return {
    f1Total,
    f2Total,
    f3Total,
    desc3D,
    descTip,
    total: f1Total + f2Total + f3Total - desc3D - descTip,
  };
};
